export default {
  FlowRecord: 'Traffic Record',
  UpFlowRecord: 'Upstream Traffic Record',
  DownFlowRecord: 'Downstream Traffic Record',
  UpFlowTitle1: 'The traffic logging feature records incoming and outgoing traffic to your gateway for you. Among them, the data for the past 30 days is the detailed traffic data, and the data more than 30 days ago will be saved in the historical traffic list for you, and the same source and destination information will be aggregated and displayed. You can check records to disable control and quickly create access control rules, you can go to ',
  AccessControl: 'Access Control',
  UpFlowTitle2: 'to view and manage.  ',//title1, AccessControl, title2 is a sentence that is unopened because access control is a clickable link
  AccessDomainIpPort: 'Access domain name/IP/port',
  UserIp: 'User IP',
  AppName: 'App Name',
  AccessFlow: 'Access traffic',
  AccessTime: 'Access Time',
  DownFlowTitle: 'The log list shows incoming and outgoing traffic information from the gateway to help you monitor network traffic. You can check the record to disable control to create access control rules, and you can go to ', // Split reasons are the same as above
  BatchControl: 'Batch Control',
  SearchPH: 'Search source IP/destination domain name/destination IPimage.png',
  BanDomain: 'Block domain name',
  SrcIpPort: 'Source IP/port',
  DestIpPort: 'Target ip/port',
  Protocol: 'Protocol',
  App: 'App',
  SetFlowControl: 'Set traffic control',
  InDirection: 'Inbound direction',
  OutDirection: 'Outbound direction',
  ControlDetail: 'Control Details',
  BanAccessDomain: 'No gateway access to the following domain names',
  BanAccessQuintuple: 'No gateway access to the following 5-tuple',
  Prompt:  'Tip',
  ExistedPrompt1: 'The current 5-tuple / domain name already has an association rule, no need to be added repeatedly, you can go to ',
  AccessControlFlow: 'Access Control - Traffic Control Rules', // prompt1 is the same as accessControlFlow split reasons
  PartialExistencePrompt: ' Some 5-tuple / domain names already have association rules, no need to be added repeatedly. The unset parts have been filtered for you, and you can continue setting. ',
  ContinueSet: 'Continue settings',
  SetSuccess: 'Set successfully',
  CreatedAccessControl: 'Access control rules have been created so that you can go to access control for viewing and management. ',
  LogDownload: 'Log Download',
  Time: 'Start time/Interval(h)',
  LogSize: 'Log size',
  Download: 'Download',
  LogDownloadAlert: 'Streaming log download function supports traffic logs within 6 month, which helps you monitor network traffic, audit and manage end users Internet behavior and troubleshoot network. You only need to check the time interval you need to download and the associated gateway to download.',
  Inquire: 'Search',
  BatchDownload: 'Batch Download',
  SettingFlowTips1: 'Setting up traffic control will generate the corresponding traffic control rules for you, you can go to',
  SettingFlowTips2: 'to view and manage. A maximum of 100 access control rules can be associated with a single gateway, the rules over will be restricted. ',
  LastAssociatedRules: 'Number of remaining associatable rules',
  SelectedAndCurrentRules: 'Number of selected/current traffic control rules',
  MaximumAssociationExceededTips: (num: number) => `The remaining number of rules that can be associated with the gateway is less than the number of rules generated by this traffic control, and they cannot all be associated with the current gateway. The first ${num} rules are selected by default, you can adjust by yourself.`,
  SetFlowControlSearchPlaceholder: 'Search for rule name information (domain name or IP)',
  FlowControlRuleTips: (totalLength: number, maxLength: number) => `Reminder: There are ${totalLength} traffic control rules, the maximum number of ${maxLength} rules can be selected, the first ${maxLength} are selected by default. If necessary, you can adjust it yourself`,
  TrafficThisMonth: 'Traffic in the past 30 days',
  Initiator: 'Initiator',
  Responder: 'Responder',
  SelectControlObject: 'Select control object',
  ConfirmControlRules: 'Confirm control rules',
  HistoryFlow: 'Historical traffic',
  AccessDate: 'Access Date',
}